import React, { useMemo} from "react";

import {DataAPI} from "../services/API";
import {PrinterStatusBadge} from "./PrinterStates";
import PrinterDetails from "./PrinterDetails";
import {RouteComponentProps, useHistory, useLocation} from "react-router-dom";
import {Helmet} from "react-helmet";
import {formatDate, VisibilityHelper} from "../commons/Utils";
import TonersInfo from "./TonersInfo";
import ReactQueryTable from "./ReactQueryTable";
import {CounterCell} from "./Components";

const ManualCounterBadge = () => <span className="manual-counter-badge manual-counter-badge-table">Ręczny licznik</span>;

const PrintersTab = (props: RouteComponentProps) => {

  const columns = useMemo(()=>[
    { Header: 'Stan', accessor: 'stateSeverity', className: 'col-status',
      Cell: ({row}) => <PrinterStatusBadge states={row.original.errorStates} serviceCauses={row.original.serviceCauses} jamLocations={row.original.jamLocations} offlineCauses={row.original.offlineCauses}/>,
    },
    {
      Header: 'Numer seryjny', accessor: 'serialNumber', className: VisibilityHelper('md-up'),
      Cell: ({row, value}) => (
        <div className="printer-serial-cell">
          <span>{value || '—'}</span>
          {row.original.manualCounter ? <ManualCounterBadge /> : null}
        </div>
      )
    },
    { Header: 'NIS', accessor: 'nis', className: VisibilityHelper('xs-up') },
    { Header: 'Nazwa', accessor: 'name' },
    { Header: 'Model', accessor: 'model', className: `${VisibilityHelper('md-up')} col-truncate` },
    { Header: 'Lokacja', accessor: 'location', className: VisibilityHelper('md-up'),
      filterColumn: (data)=>data.substring(data.lastIndexOf('/') + 1, data.length)
    },
    { Header: 'IP', accessor: 'ip', disableSortBy: true, className: VisibilityHelper('md-up')},
    { Header: 'Liczniki', accessor: 'mainCounter', className: 'col-counter',
      Cell: ({row}) => {
        const o = row.original;
        return <CounterCell rows={[
          {label: 'Główny', value: o.totalCounter},
          {label: 'Mono', value: o.monoCounter},
          {label: 'Kolor', value: o.colorCounter},
        ]}/>;
      }, disableSortBy: true
    },
    {
      Header: 'Liczniki skanów',
      accessor: 'scanCounter',
      className: 'col-counter',
      disableSortBy: true,
      Cell: ({row}) => {
        const o = row.original;
        return <CounterCell rows={[
          {label: 'Mono', value: o.scanBWCounter},
          {label: 'Kolor', value: o.scanColorCounter},
        ]}/>;
      }
    },
    { Header: 'Poziom tonerów', accessor: 'tonerState', className: 'col-toners',
      Cell: ({row}) =><TonersInfo printer={row.original} variant="bars-compact"/>,
      disableSortBy: true
    },
    {
      Header: 'Ostatni kontakt', accessor: 'lastUpdate', className: VisibilityHelper('md-up'),
      Cell: ({row}) => {
        const o = row.original;
        return o.lastContactedRaw ? formatDate(o.lastContactedRaw) : <span className="empty-cell">—</span>;
      }
    }
  ], []);

  const history = useHistory();
  const location = useLocation();

  const rowSelect = (printer) => {
    history.push({
      pathname: PrinterDetails.url.replace(':id', printer.id),
      state: { listSearch: location.pathname + location.search },
    });
  }

  const rowProps = (printer) => {
    const className = [
      printer.manualInactive ? 'printer-inactive-row' : null,
      printer.manualCounter ? 'printer-manual-counter-row' : null,
    ].filter(Boolean).join(' ');

    return className ? { className } : {};
  };

  return <>
    <Helmet>
      <title>Drukarki</title>
    </Helmet>
    {/* <PageHeader title="Drukarki"/> */}
    <ReactQueryTable type="printer" columns={columns} onClick={rowSelect} rowProps={rowProps} queryFunction={DataAPI.getPrinters} />
  </>
}

PrintersTab.url = '/printers';

export default PrintersTab;